
<template>
  <div class="router-view header footer noSidebar">
    <div
      v-if="ready"
      class="flashcard-view-container"
    >
      <span ref="flashcardTop"></span>
      <flashcard-header
        style="left: 0; top: 0;"
        :answered="answered"
        :breadcrumbs="[]"
        :flashcard="currentFlashcard"
        :title="headerTitle"
      />
      <flashcard
        :answered="answered"
        :answer-ids="answerIds"
        :category="category"
        :correct="correct"
        :flashcard="currentFlashcard"
        :raw-answer-data="rawAnswerData"
        :show-rationale="true"
        :title="5"
        @set-answer-ids="setAnswerIds"
        @set-raw-answer-data="setRawAnswerData"
      />
      <flashcard-footer
        style="left: 0;"
        :answered="answered"
        :answer-ids="answerIds"
        :correct="correct"
        :flashcard="currentFlashcard"
        :raw-answer-data="rawAnswerData"
        :show-bookmark="false"
        @nextFlashcard="goToNextFlashcard"
        @answer="answeredFlashcard"
      />
    </div>
    <completed-view
      v-show="finished"
    />
  </div>
</template>

<script>
import Flashcard from '@components/flashcards/flashcard';
import FlashcardFooter from '@components/flashcards/footer';
import FlashcardHeader from '@components/flashcards/header';
import GlobalMixin from '@/mixins/global';
import FlashcardViewMixin from '@/mixins/flashcardViews';

export default {
  components: { Flashcard, FlashcardFooter, FlashcardHeader },
  mixins: [ FlashcardViewMixin, GlobalMixin ],
  data() {
    return {
      answered: false,
      answerIds: [],
      category: {},
      correct: false,
      rawAnswerData: {},
      purchaseOrders: {},
      title: '',
      currentIndex: 0,
      headerTitle: 'Example Questions',
    };
  },
  computed: {
    flashcardSession() {
      return this.$store.getters['flashcards/currentSession'];
    },
    currentFlashcard() {
      let flashcards = this.$store.getters['flashcards/flashcards'];
      let sessionIds = this.$store.getters['flashcards/currentSession'];
      return flashcards[sessionIds[this.currentIndex]];
    },
    ready() {
      let sessionIds = this.$store.getters['flashcards/currentSession'];
      return this.$store.getters['flashcards/flashcardSessionStarted'] && this.currentIndex < sessionIds.length;
    },
    finished() {
      let sessionIds = this.$store.getters['flashcards/currentSession'];
      return this.currentIndex == sessionIds.length;
    },
  },
  mounted() {
    this.$store.dispatch('createFlashcardSession');
    // sorry about the tight coupling here but we need to make sure the init function is ran
    if (window['initializeAll']) {
      try {
        window['initializeAll']();
      } catch {}
    }
  },
  methods: {
    resetFlashcard() {
      this.answered = false;
      this.answerIds = [];
      this.rawAnswerData = null;
      this.correct = null;
    },
    goToNextFlashcard() {
      this.$refs.flashcardTop.scrollIntoView();
      this.resetFlashcard();
      this.currentIndex++;
    },
    answeredFlashcard() {
      const correct = this.evaluateAnswer(this.currentFlashcard, this.answerIds, this.rawAnswerData);
      this.correct = correct;
      this.answered = true;
    },
  },
};
</script>

<style lang='scss'>
  @import '../style/base.scss';
</style>

<style lang='scss' scoped>
  .flashcard-view-container {
    background: $white-1;
    padding: rem-calc(48) !important;

    @include breakpoint(small) {
      padding: rem-calc(24) rem-calc(16) !important;
    }
  }
  .router-view {
    bottom: 0;
    display: flex;
    flex-wrap: wrap;
    height: calc(100% - #{rem-calc(48)});
    left: rem-calc(220);
    position: absolute;
    right: 0;
    top: rem-calc(48);

    @include breakpoint(small) {
      height: calc(100% - #{rem-calc(72)});
      left: 0;
      top: rem-calc(72);
    }

    > *:first-child  {
      bottom: 0;
      box-sizing: border-box;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding: rem-calc(32) rem-calc(48);
      position: absolute;
      top: 0;
      width: 100%;

      @include breakpoint(small) {
        padding: rem-calc(16);
      }
    }

    &.header {
      > *:first-child {
        height: calc(100% - #{rem-calc(29)});
        top: rem-calc(29);
      }

      &.masteryHeader {
        > *:first-child {
          padding-top: 0;
          top: rem-calc(45);
        }
      }
    }

    &.footer {
      > *:first-child {
        bottom: rem-calc(64);
        height: calc(100% - #{rem-calc(64)});
      }

      &.masteryFooter {
        > *:first-child {
          bottom: rem-calc(44);
        }
      }
    }

    &.header.footer {
      > *:first-child {
        height: calc(100% - #{rem-calc(109)} - #{rem-calc(64)});
      }
    }

    &.masteryHeader.masteryFooter {
      > *:first-child {
        height: calc(100% - #{rem-calc(45)} - #{rem-calc(44)});
      }
    }

    &.fullscreen {
      height: 100%;
      left: 0;
      top: 0;
    }

    &.noSidebar {
      left: 0;
    }
  }

 </style>
